import { combineReducers } from "redux";
import { alert } from "./alert.reducer";
import { authentication } from "./authentication.reducer";
import { content } from "./content.reducer"; 
import { user } from "./user.reducer";

const rootReducer = combineReducers({
  alert,
  authentication,
  content,
  user
});

export default rootReducer;